import moment from "moment";
import CardDisclaimerBase from "components/General/CardDisclaimerBase";

const Disclaimer = ({ isDeferredAnnuityPlanCode }) => {
  const date = isDeferredAnnuityPlanCode
    ? moment().add(-1, "days").format("MM/DD/YYYY")
    : moment().format("MM/DD/YYYY");
  return (
    <CardDisclaimerBase
      disclaimer={`Any values displayed are current as of ${date}. The information provided is informational only; nothing herein is a contractual obligation. If there is an inconsistency between the contract and this information, the contract shall prevail.`}
    />
  );
};

export default Disclaimer;
